var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.512 4.999a.4.4 0 01.104-.271L4.883.133a.338.338 0 01.503 0 .404.404 0 010 .541L1.37 4.998l4.015 4.324a.404.404 0 010 .542.338.338 0 01-.503 0L.616 5.269a.397.397 0 01-.104-.272V5z",
    fill: "#10B1D7"
  })));
}
export default SvgIconLeftArrow;